// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'asset-allowance-claim.page.title': 'Asset Allowance Claims',
    'asset-allowance-claim.page.search_results': 'Search Results',
    'asset-allowance-claim.page.all': 'All',

    'asset-allowance-claim.button.cancel': 'Cancel',
    'asset-allowance-claim.button.select': 'Select',
    'asset-allowance-claim.button.find': 'Find Asset Depreciation Schedules',
    'asset-allowance-claim.button.search': 'Apply',
    'asset-allowance-claim.button.reset': 'Reset',

    'asset-allowance-claim.placeholder.search': 'Search asset allowance claims',

    'asset-allowance-claim.link.create_first_asset_depreciation_schedule': 'Click here to create your first asset depreciation schedule',
    'asset-allowance-claim.link.asset_depreciation_schedules': ' Return to Asset Depreciation Schedules',
    'asset-allowance-claim.link.retry': 'Click here to retry',

    'asset-allowance-claim.checkbox.all': 'Check All',
    'asset-allowance-claim.checkbox.actions_label': 'with selected',

    'asset-allowance-claim.label.capital_allowance': 'Capital Allowance',
    'asset-allowance-claim.label.asset_name': 'Asset',
    'asset-allowance-claim.label.from_date': 'From Date',
    'asset-allowance-claim.label.thru_date': 'Thru Date',
    'asset-allowance-claim.label.depreciation_amount_in_cents': 'Depreciation Amount',
    'asset-allowance-claim.label.current_value_in_cents': 'Value',

    'asset-allowance-claim.sort.field_label': 'Field',
    'asset-allowance-claim.sort.direction_label': 'Direction',
    'asset-allowance-claim.sort.direction_ascending': 'Ascending',
    'asset-allowance-claim.sort.direction_descending': 'Descending',

    'asset-allowance-claim.modal.title.asset_depreciation_schedule_delete_permanently': 'Delete Asset Depreciation Schedule',
    'asset-allowance-claim.modal.title.asset_depreciation_schedule_restore': 'Restore Asset Depreciation Schedule',

    'asset-allowance-claim.modal.message.asset_depreciation_schedule_delete_permanently':
        'Are you sure that you want to permanently delete this asset depreciation schedule? This action cannot be undone. | Are you sure that you want to permanently delete these asset allowance claims? This action cannot be undone.',
    'asset-allowance-claim.modal.message.asset_depreciation_schedule_restore': 'Are you sure that you want to restore this asset depreciation schedule? | Are you sure that you want to restore these asset allowance claims?',

    'asset-allowance-claim.success.message.asset_depreciation_schedule_created': 'Your asset depreciation schedule has been created',
    'asset-allowance-claim.success.message.asset_depreciation_schedule_updated': 'Your asset depreciation schedule has been updated',
    'asset-allowance-claim.success.message.asset_depreciation_schedule_restored': 'Your asset depreciation schedule has been restored | All selected asset allowance claims were restored',
    'asset-allowance-claim.success.message.asset_depreciation_schedule_deleted': 'Your asset depreciation schedule has been permanently deleted | All selected asset allowance claims were permanently deleted',

    'asset-allowance-claim.error.message.asset_depreciation_schedule_deleted': 'This asset depreciation schedule was already permanently deleted | These asset allowance claims were already permanently deleted',
    'asset-allowance-claim.error.message.asset_depreciation_schedule_restored': 'This asset depreciation schedule was already restored | These asset allowance claims were already restored',
    'asset-allowance-claim.error.message.error_loading_page': 'Sorry, there was an error loading asset depreciation schedule.| Sorry, there was an error loading asset allowance claims.',
};
